const rawApiUrl = import.meta.env.VITE_API_URL || 'http://127.0.0.1:5714';
const API_BASE_URL = rawApiUrl.endsWith('/api') ? rawApiUrl : `${rawApiUrl}/api`;

export const API_ENDPOINTS = {
  main: {
    auth: {
      login: `${API_BASE_URL}/auth/login`,
    },
  },
  monitoring: {
    auth: {
      login: `${API_BASE_URL}/monitoring/auth/login`,
    },
    metrics: {
      summary: `${API_BASE_URL}/edi/metrics/summary`,
      health: `${API_BASE_URL}/edi/metrics/health`,
      errors: `${API_BASE_URL}/edi/metrics/errors`,
      performance: `${API_BASE_URL}/edi/metrics/performance`,
    },
  },
};

export { API_BASE_URL };
